export const CONFIRMATION_EXPIRED_ERROR = "confirmationExpired";
